<template>
  <div>
    <the-headersider />

    <!-- Not logged in -->
    <section v-if="!isLoggedIn" class="auth-warning">
      <p>Kindly login to access this page.</p>
    </section>

    <!-- Logged in -->
    <section v-else>
      <base-card class="card">
        <div class="header">
          <h2>Estates</h2>

          <router-link to="/register/estate" class="btn-link">
            + Register Estate
          </router-link>
          <br>
             <router-link to="/register/apartment" class="btn-link">
            + Register Apartment
          </router-link>
        </div>

        <!-- Search -->
        <!-- <input
          type="search"
          v-model="search"
          class="search-input"
          placeholder="Search estate..."
        /> -->

        <!-- Table -->
        <div v-if="estates" class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Area</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="estate in estates" :key="estate.id">
                <td>
                  <router-link
                    :to="`/estate/clients/${estate.estateId}`"
                    class="estate-link"
                  >
                    {{ estate.estateName }}
                  </router-link>
                </td>
                <td>{{ estate.area }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty state -->
        <p v-else class="empty">
          No estates found.
        </p>
      </base-card>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
    };
  },

  computed: {
    estates() {
      return this.$store.getters.estates;
    },

    filteredEstates() {
      const key = this.search.toLowerCase();
      return this.estates.filter(
        estate =>
          estate.name.toLowerCase().includes(key) ||
          estate.area.toLowerCase().includes(key)
      );
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },

  created() {
    this.$store.dispatch("LoadEstates");
  },
};
</script>

<style scoped>
.card {
  max-width: 900px;
  margin: auto;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header h2 {
  margin: 0;
}

.btn-link {
  font-weight: 600;
  color: #3b82f6;
  text-decoration: none;
}

.btn-link:hover {
  text-decoration: underline;
}

.search-input {
  width: 100%;
  padding: 0.6rem;
  margin-bottom: 1rem;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.table-wrapper {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 0.7rem;
  border-bottom: 1px solid #eee;
  text-align: left;
}

.table th {
  font-weight: 600;
  background: #f9fafb;
}

.estate-link {
  color: #2563eb;
  font-weight: 500;
  text-decoration: none;
}

.estate-link:hover {
  text-decoration: underline;
}

.empty {
  text-align: center;
  color: #6b7280;
  padding: 1rem;
}

.auth-warning {
  text-align: center;
  padding: 2rem;
  color: #b91c1c;
}
</style>
